import type { AttributeFilterState } from '../../attribute-filter-state';

/** The fields an operator/value editor may write. */
export type OperatorValuePatch = Partial<Pick<AttributeFilterState, 'operator' | 'value' | 'value2'>>;

/** One autosuggest entry in a value combobox. */
export type ValueOption = { value: string; label: string };

/**
 * Autosuggest entries for a value input, from the names a query returned.
 *
 * A value is its own label on every surface — the suggestion *is* the text that
 * goes in the box — so the mapping is the same wherever the values come from,
 * and each surface differs only in which query supplied them.
 */
export function toValueOptions(values: readonly string[] | undefined): ValueOption[] {
  return (values ?? []).map((value) => ({ value, label: value }));
}
